var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "__tips_wrapper", class: [_vm.type] },
    [
      _c("font-awesome-icon", {
        staticClass: "__tips_icon",
        attrs: { icon: "exclamation-circle" }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }